import React from 'react';

import { Paper } from '@mui/material';

interface Props {
  children: React.ReactNode;
  bordered?: boolean;
}

export default function ReportCard({ children, bordered = true }: Props) {
  return (
    <Paper variant={bordered ? 'outlined' : 'elevation'} elevation={0} sx={{ overflow: 'hidden', borderRadius: 1.25 }}>
      {children}
    </Paper>
  );
}
